import { render, staticRenderFns } from "./confirmVerification.vue?vue&type=template&id=47af591e&scoped=true"
import script from "./confirmVerification.vue?vue&type=script&lang=js"
export * from "./confirmVerification.vue?vue&type=script&lang=js"
import style0 from "./confirmVerification.vue?vue&type=style&index=0&id=47af591e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_3rwm2qttujvjuolkwtduiruple/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af591e",
  null
  
)

export default component.exports